import { useState } from "react";

export const Logo = ({ imgClass = "h-12 sm:h-14", textClass = "text-2xl sm:text-3xl text-brandDarkSlate" }) => {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <span data-testid="brand-wordmark" className={`font-serif font-bold tracking-tight ${textClass}`}>
        Enchanted <span className="italic font-medium text-brandTerracotta">Glim</span>
      </span>
    );
  }

  return (
    <img
      data-testid="brand-logo"
      src="/logo.png"
      alt="Enchanted Glim"
      className={`${imgClass} w-auto object-contain [filter:brightness(0.5)_contrast(1.25)]`}
      onError={() => setFailed(true)}
    />
  );
};
